import React from 'react';
import {I18n} from 'react-redux-i18n';
import ReactTable from 'react-table';
import PropTypes from 'prop-types';
import {Refresh} from '@material-ui/icons';
import {Card, CardContent, withStyles} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import IconButton from '@material-ui/core/IconButton';

import {CustomButton} from '../../material-dashboard-pro-react/components';
import RenderOrEmpty from '../RenderOrEmpty/RenderOrEmpty';

import {style} from './style';

/**
 * Table for observed groups
 * @param {groups} groups - array of groups. Each group must have `name` and `id fields
 * @param {onAddGroupClick} onAddGroupClick
 * - callback on clicking 'add group'. Takes group id as a parameter
 * @param {onAddAllClick} onAddAllClick - callback on clicking 'add all'
 * @param {disabled} disabled - if disabled, groups can't be configured
 * @param refreshGroups - function to refresh groups. If not provided, refresh button will be hidden
*/
function ObservedGroups({
  classes,
  groups,
  disabled,
  onAddGroupClick,
  onAddAllClick,
  refreshGroups,
}) {
  const defaultPageSize = 20;

  const renderHeader = () => {
    const title = I18n.t('users.usersConfigurer.persona.groups.observedGroups');
    if (refreshGroups) {
      return (
        <div className={classes.header}>
          <IconButton
            onClick={refreshGroups}
            size="small"
          >
            <Refresh />
          </IconButton>
          <span>{title}</span>
          <span />
        </div>
      );
    }
    return (
      <div className={classes.header__titleOnly}>
        <span>{title}</span>
      </div>
    );
  };

  const renderCell = (cell) => (
    <div className={classes.cell}>
      <span title={cell.original.name ?? ''} className={classes.cell__text}>
        {cell.original.name ?? ''}
      </span>
      <RenderOrEmpty isShow={!disabled}>
        <IconButton
          onClick={() => onAddGroupClick(cell.original.id)}
          size="small"
        >
          <AddIcon fontSize="small" />
        </IconButton>
      </RenderOrEmpty>
    </div>
  );

  const column = {
    Header: renderHeader,
    Cell: renderCell,
  };

  const pageSize = Math.max(defaultPageSize, groups.length);

  return (
    <Card className={classes.mainContainer}>
      <CardContent>
        <div className={classes.addAllContainer}>
          <CustomButton onClick={onAddAllClick} disabled={disabled}>
            <div className={classes.addAllContainer__button}>
              <AddIcon fontSize="small" />
              <span>{I18n.t('users.usersConfigurer.persona.groups.addAll')}</span>
            </div>
          </CustomButton>
        </div>
        {/* @ts-ignore-next-line */}
        <ReactTable
          className={classes.table}
          data={groups ?? []}
          columns={[column]}
          filterable={false}
          sortable={false}
          showPagination={false}
          resizable={false}
          pageSize={pageSize}
          defaultPageSize={pageSize}
        />
      </CardContent>
    </Card>
  );
}

ObservedGroups.propTypes = {
  classes: PropTypes.object.isRequired,
  groups: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
  onAddGroupClick: PropTypes.func.isRequired,
  onAddAllClick: PropTypes.func.isRequired,
  refreshGroups: PropTypes.func,
  disabled: PropTypes.bool,
};

ObservedGroups.defaultProps = {
  disabled: false,
  refreshGroups: null,
};

export default withStyles(style)(ObservedGroups);
